import { FC, useContext, useEffect, useRef } from "react";
import NotificationDispatch, { showErrorNotification } from "../../../../../context/notificationContext";
import useI18n from "../../../../../hooks/useTranslations";
import { useGatesApi } from "../../../../../http/border/useGates";
import GateForm from "./GateForm";

interface EditGateProps {
  onClose: () => void;
  gateId: string;
}

const EditGate: FC<EditGateProps> = ({ onClose, gateId }) => {
  const i18n = useI18n();
  const dispatch = useContext(NotificationDispatch);
  const aborter = useRef(new AbortController());
  const gateApi = useGatesApi();

  const { data, error, trigger } = gateApi.getAdminGate(gateId, aborter.current.signal);

  useEffect(() => {
    error && dispatch(showErrorNotification(i18n, error));
  }, [error]);

  useEffect(() => {
    gateId && trigger();
  }, [gateId]);

  return <GateForm onClose={onClose} gate={data} isDisabled={!!error} isLoading={!data && !error} />;
};

export default EditGate;
